<template>
  <section class="newsletter">
    <div class="newsletter-image">
      <NuxtPicture
        loading="lazy"
        src="/images/newsletter.jpg"
        width="900"
        height="1146"
        alt=""
      />
    </div>
    <div class="newsletter-info">
      <h3>Stay up to Date with our Latest News</h3>
      <p>Signing up to our newsletter is a great way to stay informed about:</p>
      <ul>
        <li>Trail conditions</li>
        <li>Expert tips on gear and preparation</li>
        <li>Competitions</li>
      </ul>
      <form
        id="mc-embedded-subscribe-form"
        action="https://montblanctreks.us17.list-manage.com/subscribe/post?u=7116e3c0776de49b4732c2b3a&amp;id=637167c86d"
        method="post"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
        novalidate
      >
        <div id="mc_embed_signup_scroll">
          <div class="form-group">
            <div class="bt-flabels__wrapper">
              <div class="mc-field-group form-control">
                <label for="mce-FNAME">First Name </label>
                <input
                  id="mce-FNAME"
                  type="text"
                  value=""
                  name="FNAME"
                  placeholder="First name..."
                />

                <label for="mce-LNAME">Last Name </label>
                <input
                  id="mce-LNAME"
                  type="text"
                  value=""
                  name="LNAME"
                  placeholder="Last name..."
                />
              </div>
              <div class="mc-field-group">
                <label for="mce-EMAIL"
                  >Email <span class="asterisk">*</span></label
                >
                <input
                  id="mce-EMAIL"
                  type="email"
                  value=""
                  name="EMAIL"
                  class="required email"
                  placeholder="Email.."
                />
              </div>
            </div>
          </div>

          <div id="mce-responses" class="clear foot">
            <div
              id="mce-error-response"
              class="response"
              style="display: none"
            ></div>
            <div
              id="mce-success-response"
              class="response"
              style="display: none"
            ></div>
          </div>

          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px" aria-hidden="true">
            <input
              type="text"
              name="b_7116e3c0776de49b4732c2b3a_637167c86d"
              tabindex="-1"
              value=""
            />
          </div>
          <div class="optionalParent">
            <div class="clear foot">
              <input
                id="mc-embedded-subscribe"
                type="submit"
                value="Subscribe"
                name="subscribe"
                class="btn submit"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>
